module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "label": _vm.schema.label,
      "hide-details": "",
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder || ' ',
      "outlined": "",
      "dense": "",
      "suffix": _vm.abbreviation,
      "prefix": "$",
      "append-icon": "keyboard_arrow_down"
    },
    on: {
      "blur": _vm.emitAmountChange,
      "click:append": _vm.toggleFrequency
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-631cb630"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/blocks/PaymentControl.vue
// module id = 2581
// module chunks = 1